'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectHighlightedVenueId = exports.selectViewport = exports.selectIsSearching = exports.selectIsSearchable = exports.selectCenter = exports.selectZoom = exports.selectBoundingBox = exports.selectBounds = exports.selectPopup = exports.selectSearchMapState = exports.unhighlightVenue = exports.highlightVenue = exports.setIsSearching = exports.setViewport = exports.setIsSearchable = exports.setCenter = exports.setZoom = exports.setBoundingBox = exports.setBounds = exports.clearPopup = exports.setPopup = exports.SET_VIEWPORT = exports.UNHIGHLIGHT_VENUE = exports.HIGHLIGHT_VENUE = exports.CLEAR_POPUP = exports.SET_POPUP = exports.SET_IS_SEARCHING = exports.SET_IS_SEARCHABLE = exports.SET_ZOOM = exports.SET_CENTER = exports.SET_BOUNDING_BOX = exports.SET_BOUNDS = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

exports.reducer = reducer;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SET_BOUNDS = exports.SET_BOUNDS = 'classpass/searchmap/SET_BOUNDS';
var SET_BOUNDING_BOX = exports.SET_BOUNDING_BOX = 'classpass/searchmap/SET_BOUNDING_BOX';
var SET_CENTER = exports.SET_CENTER = 'classpass/searchmap/SET_CENTER';
var SET_ZOOM = exports.SET_ZOOM = 'classpass/searchmap/SET_ZOOM';
var SET_IS_SEARCHABLE = exports.SET_IS_SEARCHABLE = 'classpass/searchmap/SET_IS_SEARCHABLE';
var SET_IS_SEARCHING = exports.SET_IS_SEARCHING = 'classpass/searchmap/SET_IS_SEARCHING';
var SET_POPUP = exports.SET_POPUP = 'classpass/searchmap/SET_POPUP';
var CLEAR_POPUP = exports.CLEAR_POPUP = 'classpass/searchmap/CLEAR_POPUP';
var HIGHLIGHT_VENUE = exports.HIGHLIGHT_VENUE = 'classpass/searchmap/HIGHLIGHT_VENUE';
var UNHIGHLIGHT_VENUE = exports.UNHIGHLIGHT_VENUE = 'classpass/searchmap/UNHIGHLIGHT_VENUE';
var SET_VIEWPORT = exports.SET_VIEWPORT = 'classpass/searchmap/SET_VIEWPORT';

var setPopup = exports.setPopup = function setPopup(popup) {
  return { type: SET_POPUP, key: 'popup', value: popup };
};
var clearPopup = exports.clearPopup = function clearPopup() {
  return { type: CLEAR_POPUP, key: 'popup', value: {} };
};
var setBounds = exports.setBounds = function setBounds(bounds) {
  return { type: SET_BOUNDS, key: 'bounds', value: bounds };
};
var setBoundingBox = exports.setBoundingBox = function setBoundingBox(boundingBox) {
  return { type: SET_BOUNDING_BOX, key: 'boundingBox', value: boundingBox };
};
var setZoom = exports.setZoom = function setZoom(zoom) {
  return { type: SET_ZOOM, key: 'zoom', value: zoom };
};
var setCenter = exports.setCenter = function setCenter(center) {
  return { type: SET_CENTER, key: 'center', value: center };
};
var setIsSearchable = exports.setIsSearchable = function setIsSearchable(isSearchable) {
  return { type: SET_IS_SEARCHABLE, key: 'isSearchable', value: isSearchable };
};
var setViewport = exports.setViewport = function setViewport(viewport) {
  return { type: SET_VIEWPORT, key: 'viewport', value: viewport };
};
var setIsSearching = exports.setIsSearching = function setIsSearching(isSearching) {
  return { type: SET_IS_SEARCHING, key: 'isSearching', value: isSearching };
};
var highlightVenue = exports.highlightVenue = function highlightVenue(venueId) {
  return { type: HIGHLIGHT_VENUE, venueId: venueId };
};
var unhighlightVenue = exports.unhighlightVenue = function unhighlightVenue() {
  return { type: UNHIGHLIGHT_VENUE };
};

var selectSearchMapState = exports.selectSearchMapState = function selectSearchMapState(state) {
  return state.features.searchMap;
};
var selectPopup = exports.selectPopup = function selectPopup(state) {
  return selectSearchMapState(state).popup;
};
var selectBounds = exports.selectBounds = function selectBounds(state) {
  return selectSearchMapState(state).bounds;
};
var selectBoundingBox = exports.selectBoundingBox = function selectBoundingBox(state) {
  return selectSearchMapState(state).boundingBox;
};
var selectZoom = exports.selectZoom = function selectZoom(state) {
  return selectSearchMapState(state).zoom;
};
var selectCenter = exports.selectCenter = function selectCenter(state) {
  return selectSearchMapState(state).center;
};
var selectIsSearchable = exports.selectIsSearchable = function selectIsSearchable(state) {
  return selectSearchMapState(state).isSearchable;
};
var selectIsSearching = exports.selectIsSearching = function selectIsSearching(state) {
  return selectSearchMapState(state).isSearching;
};
var selectViewport = exports.selectViewport = function selectViewport(state) {
  return selectSearchMapState(state).viewport;
};
var selectHighlightedVenueId = exports.selectHighlightedVenueId = function selectHighlightedVenueId(state) {
  return selectSearchMapState(state).highlightedVenueId;
};

var initialState = {
  popup: {},
  bounds: null,
  zoom: null,
  boundingBox: null,
  center: null,
  isSearchable: false,
  isSearching: false,
  highlightedVenueId: null,
  viewport: null
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case SET_BOUNDS:
    case SET_ZOOM:
    case SET_IS_SEARCHABLE:
    case SET_BOUNDING_BOX:
    case SET_CENTER:
    case SET_IS_SEARCHING:
    case SET_POPUP:
    case CLEAR_POPUP:
    case SET_VIEWPORT:
      return (0, _extends4.default)({}, state, (0, _defineProperty3.default)({}, action.key, action.value));
    case HIGHLIGHT_VENUE:
      return (0, _extends4.default)({}, state, {
        highlightedVenueId: action.venueId
      });
    case UNHIGHLIGHT_VENUE:
      return (0, _extends4.default)({}, state, {
        highlightedVenueId: null
      });
    default:
      return state;
  }
}